/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_WaitingInputs */

const vi_customer_display_waiting = /** @type {(inputs: Customer_Display_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chờ thanh toán...`)
};

/**

* @param {Customer_Display_WaitingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_waiting = /** @type {((inputs?: Customer_Display_WaitingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_WaitingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_waiting(inputs)
});